import { Link } from 'react-router-dom';
import classnames from 'classnames';
import I18n from 'i18n-js';

import { CircleLoader } from '~/components/atoms/CircleLoader';

import { Either } from '~/interfaces/types';

import style from './Balance.module.scss';

type TBalance = {
  value?: number;
  to: string;
  abbreviate?: boolean;
  loading?: boolean;
  className?: string;
} & Either<
  { src: string; alt: string },
  { Icon: (props: { className: string }) => JSX.Element }
>;

// stolen from app, move to lib
const getParsedNumberWithCustomDelimiter = (
  price: number,
  abbreviate: boolean,
) => {
  let amount = price;
  let unit = '';
  let precision = 0;
  if (abbreviate) {
    if (price >= 1_000_000) {
      unit = 'M';
      amount = price / 1_000_000;
      amount = Math.floor(amount * 100) / 100;
      if (price >= 10_000_000_000) {
        precision = 0;
      } else if (price >= 1_000_000_000) {
        precision = 1;
      } else {
        precision = 2;
      }
    } else if (price >= 1_000) {
      unit = 'K';
      amount = price / 1_000;
      amount = Math.floor(amount * 10) / 10;
      precision = 1;
    }
  }
  return I18n.toCurrency(amount, {
    format: '%n%u',
    precision,
    unit,
  });
};

export default function Balance({
  value = 0,
  to,
  src,
  alt,
  abbreviate = false,
  Icon,
  loading,
  className,
}: TBalance): JSX.Element {
  const iconProps = {
    className: style.currencyImage,
  };
  return (
    <Link
      className={classnames(style.balance, className)}
      to={to}
    >
      {Icon ? (
        <Icon {...iconProps} />
      ) : (
        <img
          src={src}
          alt={alt}
          {...iconProps}
        />
      )}
      {loading ? (
        <CircleLoader size={20} />
      ) : (
        getParsedNumberWithCustomDelimiter(value, abbreviate)
      )}
    </Link>
  );
}
